export type ValueOf<T> = T[keyof T];

export type Unbox<T> = T extends (infer U)[] ? U : T;

export type Full<T> = {
  [P in keyof T]-?: T[P];
};

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>;
};

export function isOfType<T>(
  obj: unknown,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- load-bearing: a concrete type breaks the build or changes behaviour; revisit during refactor/stack upgrade
  predicate: (obj: any) => boolean,
): obj is T {
  return predicate(obj);
}

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;
